const cdnBase = 'https://res.cloudinary.com/dtoc8w3mi/image/upload';

export const IMAGES = {
  AI_ASSISTANT: `${cdnBase}/f_auto,q_auto,w_600/v1746272812/ChatGPT_Image_May_2_2025_11_16_51_AM_qaljx6.png`,
  AI_ICON: `${cdnBase}/f_auto,q_auto,w_64/v1746272854/favicon_xkeup8.ico`,
  CAR_LOGO: `${cdnBase}/f_auto,q_auto,w_300/v1771431548/can_you_edit_the_colors_to_use_Nano_Banana_Pro_49954-removebg-preview_sg9fpt.png`,
  NMVITS_LOGO: `${cdnBase}/f_auto,q_auto,w_200/v1749296862/card_NMVTIS-logo_nez52u.webp`,
  NHTSA_LOGO: `${cdnBase}/f_auto,q_auto,w_200/v1749296862/nhtsa-brand_aduze1.png`,
  DMV_LOGO: `${cdnBase}/f_auto,q_auto,w_200/v1749296862/651c99623c8a3_erlmej.webp`,
  BLACK_LOGO: `${cdnBase}/f_auto,q_auto,w_200/v1749296862/images_tpbny7.png`,
  CLEARVIN_LOGO: `${cdnBase}/f_auto,q_auto,w_200/v1749296862/cv_smvngv.jpg`,
  REPORT_PREVIEW: `${cdnBase}/f_auto,q_auto,w_600/v1753610027/Mood_Board_Brainstorm_Whiteboard_yc2ftw.png`,
  AI_REPORT: `${cdnBase}/f_auto,q_auto,w_500/v1754308600/WhatsApp_Image_2025-08-03_at_12.33.26__1_-removebg-preview_ef776m.png`,
  AI_LAPTOP: `${cdnBase}/f_auto,q_auto,w_500/v1754308639/WhatsApp_Image_2025-08-03_at_12.33.26-removebg-preview_xle6jq.png`,
  AI_HAPPY: `${cdnBase}/f_auto,q_auto,w_500/v1754309082/ChatGPT_Image_Jul_29__2025__11_37_20_AM-removebg-preview_o4z4o7.png`,
  AI_ASK: `${cdnBase}/f_auto,q_auto,w_500/v1761341547/Add_a_little_bit_of_body_text__1_-removebg-preview_cpzuvf.png`,
};

/**
 * Responsive srcSet strings for images used at different sizes on mobile vs desktop.
 * Use alongside the IMAGES src: <img src={IMAGES.X} srcSet={IMAGE_SRCSET.X} sizes="..." />
 * The `src` fallback is unchanged so all existing uses stay working.
 */
export const IMAGE_SRCSET = {
  AI_ASSISTANT: [
    `${cdnBase}/f_auto,q_auto,w_300/v1746272812/ChatGPT_Image_May_2_2025_11_16_51_AM_qaljx6.png 300w`,
    `${cdnBase}/f_auto,q_auto,w_450/v1746272812/ChatGPT_Image_May_2_2025_11_16_51_AM_qaljx6.png 450w`,
    `${cdnBase}/f_auto,q_auto,w_600/v1746272812/ChatGPT_Image_May_2_2025_11_16_51_AM_qaljx6.png 600w`,
  ].join(', '),
  REPORT_PREVIEW: [
    `${cdnBase}/f_auto,q_auto,w_320/v1753610027/Mood_Board_Brainstorm_Whiteboard_yc2ftw.png 320w`,
    `${cdnBase}/f_auto,q_auto,w_500/v1753610027/Mood_Board_Brainstorm_Whiteboard_yc2ftw.png 500w`,
    `${cdnBase}/f_auto,q_auto,w_600/v1753610027/Mood_Board_Brainstorm_Whiteboard_yc2ftw.png 600w`,
  ].join(', '),
  AI_REPORT: [
    `${cdnBase}/f_auto,q_auto,w_280/v1754308600/WhatsApp_Image_2025-08-03_at_12.33.26__1_-removebg-preview_ef776m.png 280w`,
    `${cdnBase}/f_auto,q_auto,w_400/v1754308600/WhatsApp_Image_2025-08-03_at_12.33.26__1_-removebg-preview_ef776m.png 400w`,
    `${cdnBase}/f_auto,q_auto,w_500/v1754308600/WhatsApp_Image_2025-08-03_at_12.33.26__1_-removebg-preview_ef776m.png 500w`,
  ].join(', '),
  AI_LAPTOP: [
    `${cdnBase}/f_auto,q_auto,w_280/v1754308639/WhatsApp_Image_2025-08-03_at_12.33.26-removebg-preview_xle6jq.png 280w`,
    `${cdnBase}/f_auto,q_auto,w_400/v1754308639/WhatsApp_Image_2025-08-03_at_12.33.26-removebg-preview_xle6jq.png 400w`,
    `${cdnBase}/f_auto,q_auto,w_500/v1754308639/WhatsApp_Image_2025-08-03_at_12.33.26-removebg-preview_xle6jq.png 500w`,
  ].join(', '),
  AI_HAPPY: [
    `${cdnBase}/f_auto,q_auto,w_280/v1754309082/ChatGPT_Image_Jul_29__2025__11_37_20_AM-removebg-preview_o4z4o7.png 280w`,
    `${cdnBase}/f_auto,q_auto,w_400/v1754309082/ChatGPT_Image_Jul_29__2025__11_37_20_AM-removebg-preview_o4z4o7.png 400w`,
    `${cdnBase}/f_auto,q_auto,w_500/v1754309082/ChatGPT_Image_Jul_29__2025__11_37_20_AM-removebg-preview_o4z4o7.png 500w`,
  ].join(', '),
  AI_ASK: [
    `${cdnBase}/f_auto,q_auto,w_280/v1761341547/Add_a_little_bit_of_body_text__1_-removebg-preview_cpzuvf.png 280w`,
    `${cdnBase}/f_auto,q_auto,w_400/v1761341547/Add_a_little_bit_of_body_text__1_-removebg-preview_cpzuvf.png 400w`,
    `${cdnBase}/f_auto,q_auto,w_500/v1761341547/Add_a_little_bit_of_body_text__1_-removebg-preview_cpzuvf.png 500w`,
  ].join(', '),
};
